// vgm业务数据--增删改查
import request from '@/api/requestTwo'

import { MODE_CONF } from '@/utils/config'
//const serve="http://192.168.60.120:30770"
const serve = MODE_CONF.base_url_agent
//const cpsServe=process.env.VUE_APP_API_CPS

//是否第一次使用
export function firstTimeUsing() {
    return request({
        url: serve+`/agent/website/isFirstUsed`,
        method: 'get',

    })
}
//获取草稿箱列表
export function getDraftBoxList(params) {
    return request({
        url: serve+`/agent/website/list`,
        method: 'get',
        params
    })
}
//保存到草稿箱
export function saveDraftBox(data) {
    return request({
        url: serve+`/agent/website/saveDraft`,
        method: 'post',
        data
    })
}
//详情
export function draftBoxDetail(params) {
    return request({
        url: serve+`/agent/website/detail`,
        method: 'get',
        params
    })
}
//编辑
export function editDraftBox(id,data) {
    return request({
        url:serve+ `/agent/website/updateDraft?id=${id}`,
        method: 'POST',
        data
    })
}
//发送前的费用确认
export function feeConfirmation(data) {
    return request({
        url:serve+ `/agent/website/checkFee`,
        method: 'POST',
        data
    })
}
//批量发送
export function bulkSend(data) {
    return request({
        url:serve+ `/agent/website/batchSend`,
        method: 'POST',
        data
    })
}
//更新备注
export function updateNotes(data) {
    return request({
        url:serve+ `/agent/website/updateUserRemark`,
        method: 'POST',
        data
    })
}
//文件导入
export function fileImport(data) {
    return request({
        url:serve+ `/agent/import/excel`,
        method: 'POST',
        data
    })
}
//vgm引流
export function vgmDrainage(id) {
    // return request({
    //     url:cpsServe+ `/ccam/orders/ccamSendVGMV2/${id}`,
    //     method: 'get',
    // })
}
//批量删除
export function delDraftBox(data) {
    return request({
        url:serve+ `/agent/website/deleteDraft`,
        method: 'POST',
        data
    })
}
